import React, { useEffect, useState } from 'react';
import { Container, Typography, Button, Box, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom'; // You may need to adjust this import based on your project setup
import { ArrowRight } from '@material-ui/icons';
const contentStyle = {
  width: 'fit-content',
  margin: 'auto auto',
  textAlign: 'center',background: "rgba(0, 0, 0, 0.5)",
  border: '1px solid transparent',
  boder: 'linear-gradient(to bottom, transparent, transparent 15%, rgba(255, 0, 0, 0.5))',
  boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)',
  transition: 'border 0.4s, box-shadow 0.3s',
  cursor: 'pointer',
 
};

const buttonStyle = {
  marginBottom: '20px',
  height: '60px',
  fontSize: '18px',
  lineHeight: '19px',
  padding: '0 36px',
  borderRadius: '9px', // Enclosed in quotes
  background: "#5858e6",
    border: "1px solid #5858e6",
    boxShadow: "0 1px 2px rgba(0,0,0,.07)"

};


function ParallaxComponent() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs once after the component mounts

  return (
    <div>
      <div
        style={{
          backgroundImage: 'url(heroImage.png)',
          backgroundSize: 'cover',
          backgroundPosition: `center ${scrollY * 0.6}px`, // Adjust the multiplier for the parallax effect
          height: "fit-content" // Set the height to the viewport height
        }}
      >
    <Container
  style={{
    position: 'relative',
    zIndex: 1,
    padding:"0px",
    top: "10%",    margin:"auto auto",
    width:"fit-content"
   
  }}

>


    

<Box  sx={{ flexDirection: { xs: 'column',lg: 'column' } }} style={{margin:"0 auto", width:"fit-content",display: 'flex', alignItems:"center", display:"flex" ,justifyContent:"space-between", backdropFilter: 'blur(2px)',     color: 'white ',
}} >
    <Box style={{width:"fit-content",maxWidth:"800px" ,display: 'flex', alignItems:"center", display:"flex" ,flexDirection:"column",justifyContent:"space-between"}}>
           {/* left side */}
           <Typography gutterBottom variant='h5' style={{ fontFamily: 'Chakra Petch, sans-serif', alignItems: 'justify', fontSize: '50px', textAlign: 'center', lineHeight: '1.2' }}>
           Explore Possibilities with {' '}
      <span
        style={{
          background: 'linear-gradient(225deg, #ff5858 40%, #f09819)',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
        }}
      >
AI Imagery
      </span>
    </Typography >
     
      <Typography gutterBottom  variant="h2"style={{fontFamily:"Poppins, sans-serif",fontSize:"20px",textAlign:"center"}} paragraph>
      Immerse in our AI-powered Adult Content Generator. Let it bring desires to life, where passion meets technology, unleash inner desires. Embark on a {' '}
      <span
        style={{
          background: 'linear-gradient(225deg, #ff5858 40%, #f09819)',

          WebkitBackgroundClip: 'text',
          color: 'transparent',
        }}
      >
journey of intimate possibilities today.</span>{' '}  
      </Typography>     
      
      <Button
        component={Link}
        to="/gallery"
        variant="contained"
        color="primary"
        style={buttonStyle}
      >
        Explore More <ArrowRight/>
      </Button>
      </Box>

       {/* right side */}

  
   
          <Box
      sx={{
        
        position: 'relative',
        textAlign: 'center',
      }}
    >
      <video
        src="homePage/heroVideo.webm"
        alt="Manga"
        style={{    width:"100%", minWidth: "280px", maxWidth:"fit-content",
          objectFit: "cover",
          maxHeight: "400px" }}
        autoPlay  // Add the autoplay attribute
        muted 
        loop  // Add the muted attribute for reliable autoplay
      />
    </Box>




    </Box>















        </Container>
      </div>
    </div>
  );
}

export default ParallaxComponent;
